<!--
 * @FileDescription: 修改密码模块
 * @Author: 陈文景
 * @Date: 未知
 * @LastEditors: 陈文景
 * @LastEditTime: 2022-09-22 14:30:32
-->
<template>
  <div class="edit-password-box">
    <span class="edit-password-title">修改密码</span>
    <el-form label-position="top" ref="form" :rules="editPasswordRules" :model="form">
      <el-form-item label="邮箱号" prop="email">
        <el-input size="medium" v-model.trim="form.email" placeholder="请输入邮箱号" />
      </el-form-item>
      <el-form-item label="验证码" prop="verificationCode">
        <el-row>
          <el-col :span="14">
            <el-input size="medium" v-model.trim="form.verificationCode" placeholder="请输入验证码" />
          </el-col>
          <el-col :span="10">
            <el-button size="medium" style="margin-left: 5px;" @click="handleGetCode">获取验证码</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input size="medium" type="password" show-password v-model.trim="form.password" placeholder="请输入新密码" auto-complete="new-password" />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input :disabled="!form.password" size="medium" type="password" show-password v-model.trim="form.confirmPassword" placeholder="请输入确认密码" />
      </el-form-item>
    </el-form>
    <el-button class="edit-password-btn-ok" size="medium" type="primary" @click="confirmEditPassword">确 定</el-button>
    <div class="return-login">
      <span @click="returnLogin">返回登录</span>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { encrypt } from '@/utils/encryp'

export default {
  data() {
    let checkEmail = (rule, value, callback) => {
      let reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确的邮箱号'))
      } else {
        callback()
        this.$refs.form.clearValidate('email')
      }
    }

    let checkCode = (rule, value, callback) => {
      let reg = /^\d{6}$/
      if (!value) {
        callback(new Error('请输入6位数字验证码'))
      } else if (!reg.test(value)) {
        callback(new Error('验证码格式不正确'))
      } else {
        callback()
        this.$refs.form.clearValidate('verificationCode')
      }
    }

    let checkEditPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (value.length<8 || value.length>20) {
        callback(new Error('请输入8到20个字符的密码'))
      } else {
        callback()
        this.$refs.form.clearValidate('password')
      }
    }

    let checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入确认密码'))
      } else if (this.form.password !== this.form.confirmPassword) {
        callback(new Error('新密码与确认密码不一致'))
      } else {
        callback()
        this.$refs.form.clearValidate('confirmPassword')
      }
    }

    return {
      editPasswordRules: {
        email: [{ validator: checkEmail, trigger: ['blur', 'change'] }],
        verificationCode: [{ validator: checkCode, trigger: ['blur', 'change'] }],
        password: [{ validator: checkEditPassword, trigger: ['blur', 'change'] }],
        confirmPassword: [{ validator: checkConfirmPassword, trigger: ['blur', 'change'] }]
      },
      form: {
        email: undefined, // 手机号
        verificationCode: undefined, // 验证码
        password: undefined, // 密码
        confirmPassword: undefined // 确认密码
      }
    }
  },
  methods: {
    // 获取验证码
    async handleGetCode() {
      let reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/
      if (!this.form.email) {
        this.$message.warning('请输入邮箱号')
      } else if (!reg.test(this.form.email)) {
        this.$message.warning('请输入正确的邮箱号')
      } else {
        let result = await API.getVerificationCode({ email: this.form.email })
        if (result.code !== 10000) {
          return this.$message.error(result.message)
        }
        this.$message.success('验证码已发送，请查收')
      }
    },

    // 确认编辑密码按钮事件
    confirmEditPassword() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        // 先验证邮箱和验证码是否正确
        let result = await API.forgetPassword({ email: this.form.email, verificationCode: this.form.verificationCode })
        if (result.code !== 10000) {
          return this.$message.error(result.message)
        }
        // 再提交修改密码
        let isOk = await API.editPassword({ email: this.form.email, password: encrypt(this.form.password) })
        if (isOk.code !== 10000) {
          return this.$message.error(isOk.message)
        }
        this.returnLogin()
        this.$message.success(isOk.message)
      })
    },

    // 返回登陆
    returnLogin() {
      this.$emit('returnLogin')
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-password-box {
  width: 280px;
  .edit-password-title {
    display: inline-block;
    width: 100%;
    line-height: 38px;
    text-align: center;
    margin-bottom: 12px;
  }
  .el-form-item {
    margin-bottom: 12px !important;
  }
  /deep/.el-form-item__label {
    line-height: 28px;
    padding: 0 !important;
  }
  .edit-password-btn-ok {
    width: 100%;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .edit-password-btn-ok {
    margin-top: 8px;
  }
  .return-login {
    display: inline-block;
    width: 100%;
    color: rgb(153, 196, 28);
    font-size: 13px;
    text-align: right;
    margin-top: 8px;
    span {
      user-select: none;
      cursor: pointer;
    }
  }
}
</style>